export type StakingViews = "stake" | "unstake" | "migrating";

export enum EFormFields {
  STAKE = "stake",
  AGREEMENT = "agreement",
}
